import { render, staticRenderFns } from "./SupplierNameDialog.vue?vue&type=template&id=59b183e2"
import script from "./SupplierNameDialog.vue?vue&type=script&lang=js"
export * from "./SupplierNameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports